import { styled, FormControlLabel } from '@mui/material';

export const StyledFormControlLabel = styled(FormControlLabel)`
  & + & {
    margin-left: 12px;
  }
`;
